import { useState } from "react";
import { portalClienteLogin } from "../api/functions";

const BRAND = { primary: "#0FC9C5", dark: "#0f172a", card: "#1e293b", border: "#334155" };
const LOGO = "https://media.base44.com/images/public/692ce8b41b53f8d1d71b7ec7/a124921b8_693263386.jpg";

export default function Login({ onLogin }) {
  const [form, setForm] = useState({ email: "", senha: "" });
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErro("");
    try {
      const data = await portalClienteLogin({ email: form.email, senha: form.senha });
      if (data.success) { onLogin(data.usuario); }
      else { setErro(data.error || "Email ou senha inválidos"); }
    } catch { setErro("Erro de conexão. Tente novamente."); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: "100vh", background: `linear-gradient(135deg, #0f172a 0%, #1e3a5f 100%)`, display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}>
      <div style={{ background: BRAND.card, border: `1px solid ${BRAND.border}`, borderRadius: "20px", padding: "40px", width: "100%", maxWidth: "400px", boxShadow: "0 25px 50px rgba(0,0,0,0.5)" }}>
        <div style={{ textAlign: "center", marginBottom: "32px" }}>
          <img src={LOGO} alt="Logo" style={{ height: "72px", borderRadius: "12px", marginBottom: "16px" }} onError={e => e.target.style.display = "none"} />
          <h1 style={{ color: "#f1f5f9", fontSize: "22px", fontWeight: "700", margin: "0 0 6px" }}>Portal Cliente</h1>
          <p style={{ color: "#64748b", fontSize: "13px" }}>IntegraConnect · Área do Cliente</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "16px" }}>
            <label style={{ display: "block", fontSize: "12px", fontWeight: "600", color: "#94a3b8", marginBottom: "6px", textTransform: "uppercase", letterSpacing: "0.05em" }}>E-mail</label>
            <input type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="seu@email.com" required
              style={{ width: "100%", padding: "12px 14px", background: "#0f172a", border: `1.5px solid ${BRAND.border}`, borderRadius: "10px", color: "#f1f5f9", fontSize: "14px", outline: "none" }}
              onFocus={e => e.target.style.borderColor = BRAND.primary}
              onBlur={e => e.target.style.borderColor = BRAND.border} />
          </div>
          <div style={{ marginBottom: "24px" }}>
            <label style={{ display: "block", fontSize: "12px", fontWeight: "600", color: "#94a3b8", marginBottom: "6px", textTransform: "uppercase", letterSpacing: "0.05em" }}>Senha</label>
            <input type="password" value={form.senha} onChange={e => setForm({ ...form, senha: e.target.value })} placeholder="••••••••" required
              style={{ width: "100%", padding: "12px 14px", background: "#0f172a", border: `1.5px solid ${BRAND.border}`, borderRadius: "10px", color: "#f1f5f9", fontSize: "14px", outline: "none" }}
              onFocus={e => e.target.style.borderColor = BRAND.primary}
              onBlur={e => e.target.style.borderColor = BRAND.border} />
          </div>

          {erro && (
            <div style={{ background: "#450a0a", border: "1px solid #991b1b", color: "#fca5a5", padding: "10px 14px", borderRadius: "8px", fontSize: "13px", marginBottom: "16px" }}>{erro}</div>
          )}

          <button type="submit" disabled={loading} style={{
            width: "100%", padding: "13px", background: loading ? "#1e293b" : `linear-gradient(135deg, ${BRAND.primary}, #0891b2)`,
            color: "#fff", border: "none", borderRadius: "10px", fontWeight: "700", fontSize: "15px",
            cursor: loading ? "not-allowed" : "pointer", transition: "opacity 0.2s"
          }}>
            {loading ? "Verificando..." : "Entrar"}
          </button>
        </form>

        <p style={{ textAlign: "center", marginTop: "24px", fontSize: "12px", color: "#475569" }}>
          Acesso restrito. Credenciais fornecidas pela equipe IntegraConnect.
        </p>
      </div>
    </div>
  );
}
